import { useState } from "react";
import { Link } from "@shopify/hydrogen/client";
import { ChevronRight, GlobeIcon, ChevronDown, LeftChevron } from "@components/atoms/Icons/index";
import { useResponsiveNavbar } from "@models/interactions/use-responsive-navbar/index" 
import { NavbarMenu } from "@models/types/menu.interface";
import { TranslationMenu } from "../translation-menu/index.client";

export function useNavigationResponsive() {
  const [item, setItem] = useState<NavbarMenu | null>(null);

  const selectItem = (selected: NavbarMenu | null) => {
    setItem(selected);
  };

  return {
    model: {
      item,
    },
    operations: {
      selectItem,
    }
  };
}

export default function NavigationResponsive({ menu }: { menu: any }) {
  const { model, operations } = useNavigationResponsive();

  if (model.item) {
    return (
      <>
        <div
          className="flex items-center mt-[110px] mx-5 font-chivo-bold uppercase"
          onClick={() => operations.selectItem(null)}
        >
          <LeftChevron height="18px" width="12px" className="inline-block mr-[17px]" />
          {model.item.title}
        </div>
        <nav className="flex flex-col w-auto mt-[26.6px] mx-5 space-y-5 uppercase">
          {(model.item.items || []).map((item: any) => (
            <Link
              key={item.slug}
              to={item.url}
              onClick={() => useResponsiveNavbar().operations.openDrawer()}
              className="font-chivo-regular w-[221px] text-base flex items-center justify-between"
            >
              {item.titleResponsive || item.title}
            </Link>
          ))}
        </nav>
      </>
    );
  }

  return (
    <>
      <nav className="flex flex-col mt-[160.6px] w-auto mx-5 space-y-5 ">
        {(menu || []).map((item: any) => {
          if (item.items.length) {
            return (
              <span
                key={item.slug}
                onClick={() => operations.selectItem(item)}
                className="font-chivo-regular w-[221px] text-base flex items-center justify-between"
              >
                {item.title}
                <ChevronRight height="18px" width="12px" />
              </span>
            );
          }

          return (
            <Link
              key={item.slug}
              to={item.url}
              onClick={() => useResponsiveNavbar().operations.openDrawer()}
              className="font-chivo-regular w-[221px] text-base flex items-center justify-between"
            >
              {item.title}
            </Link>
          );
        })}
      </nav>
      <div className="mx-5 mt-[35px] w-[67px]">
        <TranslationMenu
            classname="flex justify-between items-center text-sm font-chivo-regular text-dark-gray"
            height="6px"
            width="10px"
            pclassname="pl-1"
            rigth={false}
          />
      </div>
    </>
  );

  // return (
  //   <>
  //     <nav className="flex flex-col mt-[160.6px] w-auto mx-5 space-y-5 ">
  //       {/* Top level menu items */}
  //       {(menu?.items || []).map((item: any) => (
  //         <Link
  //           key={item.id}
  //           to={item.to}
  //           onClick={useResponsiveNavbar().operations.openDrawer}
  //           className="font-chivo-regular w-[221px] text-base flex items-center justify-between"
  //         >
  //           {item.title}
  //           {item.title !== ChevronPresenterKeys.ABOUT_US && item.title !== ChevronPresenterKeys.STORE_LOCATOR && (
  //             <ChevronRight height="18px" width="12px" />
  //           )}
  //         </Link>
  //       ))}
  //     </nav>
  //     <div className="mx-5 mt-[35px] w-[67px]">
  //       <div className="flex justify-between items-center text-sm font-chivo-regular text-dark-gray">
  //         <GlobeIcon width="20px" height="20px" />
  //         <p className="pl-1">EN</p>
  //         <ChevronDown width="10px" height="6px" />
  //       </div>
  //     </div>
  //   </>
  // );
}
